import invariant from 'invariant';

import { Phase } from './Phases';
import * as Rules from './Rules';

import nullthrows from 'nullthrows';
import { GameComputedState, GamePlayerComputedState } from './GameModel';
import Player from './Player';

import { ActionTypes, GameAction } from './GameActions';

export default class Bot {
  constructor() {}

  // TODO(ldg): this should take in a GameViewModel probably
  actionForGameState(
    game_state: GameComputedState,
    user_id: string,
  ): GameAction | null {
    invariant(
      game_state.playerStates.find((player) => player.userID === user_id),
      'bot not in game',
    );

    if (game_state.winningPlayerIDs) {
      return null;
    }

    // if (game_state.readyByUserID[user_id]) {
    //   return null;
    // }

    if (game_state.phase === Phase.PLANNING) {
      return {
        type: ActionTypes.BID,
        bid: this.computeBid(game_state, user_id),
      };
    } else if (game_state.phase === Phase.RESOLUTION) {
      return {
        type: ActionTypes.RESOLVE,
        resolve: this.computeResolutionSelection(game_state, user_id),
      };
    } else {
      invariant(false, 'unexpected phase %s', game_state.phase);
    }
  }

  // helpers

  getPlayer(
    game_state: GameComputedState,
    user_id: string,
  ): GamePlayerComputedState {
    return nullthrows(
      game_state.playerStates.find((player) => player.userID === user_id),
    );
  }

  getContext(game_state: GameComputedState, player: Player): Rules.Context {
    return Rules.makeContext(
      player,
      game_state.turn,
      game_state.age,
      game_state.options,
    );
  }

  // Subclasses begin overriding here
  computeBid(game_state: GameComputedState, user_id: string): Rules.Bid {
    return {
      military: 0,
      tradeRowIndex: 0,
    };
  }

  computeResolutionSelection(
    game_state: GameComputedState,
    user_id: string,
  ): Rules.ResolutionSelection {
    return {
      cardIDToGain: game_state.basicPile[0].id,
    };
  }
}
